/**
 * Created by sagardesai on 11/07/18.
 */

import * as types from "../../actions/types/index";
import {setInitialState} from "../../util/utility";

const INITIAL_STATE = setInitialState({
    payload: null,
    messageModal: null
});

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {
        case types.SEND_MESSAGE_REQUEST:
            return {
                ...state,
                isFetching: true,
            };
        case types.SEND_MESSAGE_RECEIVE:
            return {
                ...state,
                isFetching: false,
                isSuccess: true,
                payload: action.payload
            };
        case types.SEND_MESSAGE_FAILURE:
            return {
                ...state,
                isFetching: false,
                isError: true,
                payload: action.payload.response.error,
            };
        case types.RESET_SEND_MESSAGE:
            return {
                ...state,
                payload: action.payload,
            };
        case types.SHOW_MESSAGE_MODAL:
            return {
                ...state,
                messageModal: action.payload
            };
        case types.HIDE_MESSAGE_MODAL:
            return {
                ...state,
                messageModal: action.payload
            };
        default:
            return {
                ...state
            }
    }
}